// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"CatalogDisplay_gridContainer__h2fiX","listContainer":"CatalogDisplay_listContainer__qmcNR"};